import { PropsWithChildren } from 'react'
import { Text, TextVariant } from 'blaze-ui/Text/Text'

export const Message = ({ children, variant = 'largeList' }: PropsWithChildren<{ variant?: TextVariant }>) => (
  <Text variant={variant}>{children}</Text>
)
